<template>
  <div class="w w1200">
    <!-- 面包屑导航 -->
    <el-breadcrumb
      class="breakcrumbHeader"
      separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>{{ type == 1 ? '资讯中心' : '帮助中心'}}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="20">
      <el-col :span="5">
        <el-card header="文章分类" shadow="never">
          <ul class="list" v-if="categoryList.length">
            <li class="list-item"
                @click="search(cate)"
                v-for="cate in categoryList" :key="cate.categoryId">
              <span class="text">{{cate.categoryName}}</span>
            </li>
          </ul>
          <empty v-else>暂无相关分类！</empty>
        </el-card>
      </el-col>
      <el-col :span="19" class="rightaside">
        <el-card :header="currentCategory ? currentCategory.categoryName : ''" shadow="never">
          <div class="article-list" v-if="total">
            <router-link tag="div" :to="`/articleDetail?type=${type}&articleId=${article.articleId}`" class="article-item"
                 v-for="article in articleList" :key="article.articleId">
              <el-image class="cover" :src="article.articleImage"></el-image>
              <div class="info">
                <div class="article-name">{{article.articleTitle}}</div>
                <div class="article-data">
                  <i class="el-icon-time"></i>
                  <span>{{article.createTime | formatTime('yyyy-MM-dd')}}</span>
                </div>
              </div>
            </router-link>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="{
              pageSize: this.pageSize,
              currentPage: this.pageIndex,
              total: this.total,
            }" @callFather="loadMore"></Pagination>
          </div>
          <empty v-else>暂无相关文章！</empty>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {newsCategory, helpCategory, articleList} from '../../api/xunyou'
import Pagination from '../../components/Pagination';
export default {
  data() {
    return {
      cateLoading: false,
      listLoading: false,
      currentCategory: null,
      articleList: [],
      categoryList: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0
    };
  },
  components: {
    Pagination
  },
  computed: {
    type () {
      return this.$route.query.type || 1;
    }
  },
  watch: {
    '$route': function (to, from) {
      console.log('路由数据：', to);
      this.getCategoryList();
    }
  },
  created() {
    this.getCategoryList();
  },
  methods: {
    getCategoryList () {
      this.cateLoading = true;
      let _promise = null;
      if (this.type == 1) {
        _promise = newsCategory();
      } else {
        _promise = helpCategory();
      }
      _promise.then(res => {
        console.log('分类列表：', res);
        if (res.code === 0) {
          this.categoryList = res.data.subCategoryList;
          this.search(this.categoryList[0]);
        }
      }).catch(err => {
        console.error('错误：', err);
      }).finally(() => {
        this.cateLoading = false;
      });
    },
    search(category) {
      this.currentCategory = category;
      this.pageIndex = 1;
      this.getList();
    },
    loadMore ({currentPage, pageSize}) {
      this.pageIndex = currentPage;
      this.pageSize = pageSize;
      this.getList();
    },
    getList() {
      const params = {
        pageNum: this.pageIndex,
        pageSize: this.pageSize,
        categoryId: this.currentCategory ? this.currentCategory.categoryId : '-1'
      }
      this.listLoading = true;
      articleList(params).then(res => {
        console.log('文章列表：', res);
        if (res.code === 0) {
          this.total = res.total
          this.articleList = res.rows;
        }
      }).catch(err => {
        console.error('错误：', err);
      }).finally(() => {
        this.listLoading = false;
      })
    }
  }
};
</script>

<style scoped lang="less">
.breakcrumbHeader {
  margin: 15px 0;
}
/deep/ .el-card__body{
  padding: 0;
}
/deep/ .el-card__header{
  padding: 10px;
  font-size: 16px;
  font-weight: 500;
}
.list {
  .list-item{
    position: relative;
    font-size: 14px;
    padding: 15px 0;
    line-height: 1;
    cursor: pointer;
    &:hover{
      color: var(--main-theme-color);
    }
    &:before{
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      content: '';
      height: 20px;
      border-left: 5px solid var(--main-theme-color);
    }
  }
}
.article-list{
  padding: 15px;
}
.article-item{
  display: flex;
  justify-content: flex-start;
  align-self: center;
  margin-bottom: 15px;
  .cover{
    width: 80px;
    height: 80px;
    margin-right: 10px;
  }
  .info{
    flex: 1;
  }
  .article-name{
    height: 42px;
    font-size: 14px;
    font-weight: 500;
    overflow: hidden;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    cursor: pointer;
    &:hover{
      text-decoration: underline;
    }
  }
  .article-data{
    margin-top: 15px;
    color: #888888;
  }
}

</style>







// WEBPACK FOOTER //
// src/views/serviceArticle/index.vue